/**
 * battle 领域的 GameState 分片注册（持久化战斗状态）。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { PersistentBattleStateSchema, type PersistentBattleState } from './types/battle';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    /** 持久化战斗状态（用于存档恢复）；新档缺省 */
    persistentBattleState?: PersistentBattleState;
  }
}

registerGameStateSlice('persistentBattleState', PersistentBattleStateSchema.optional());
